module.exports = __webpack_public_path__ + "assets/guard-7240defb.svg";